module.exports = __webpack_public_path__ + "img/success.99bf0cf9.png";